import { render, staticRenderFns } from "./NeiBuFile3.vue?vue&type=template&id=6bd2c671&scoped=true&"
import script from "./NeiBuFile3.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile3.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile3.vue?vue&type=style&index=0&id=6bd2c671&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd2c671",
  null
  
)

export default component.exports